<div
  class="asset-card"
  [ngClass]="{
    'zero-token': isZeroToken,
    'policy-bound': !isZeroToken && !isPermanentPolicy,
    'permanent': !isZeroToken && isPermanentPolicy
  }"
  fxLayout="column"
  fxLayoutAlign="space-between stretch"
>
  <!-- Header -->
  <div class="header" fxLayout="row" fxLayoutAlign="space-between center">
    <div class="token-icon">
      <mat-icon *ngIf="isZeroToken">account_balance_wallet</mat-icon>
      <mat-icon *ngIf="!isZeroToken && !isPermanentPolicy">lock</mat-icon>
      <mat-icon *ngIf="!isZeroToken && isPermanentPolicy">lock_clock</mat-icon>
    </div>
    <div class="token-type">
      <span *ngIf="isZeroToken">Unrestricted</span>
      <span *ngIf="!isZeroToken && !isPermanentPolicy">Policy-Bound</span>
      <span *ngIf="!isZeroToken && isPermanentPolicy">Permanent Policy</span>
    </div>
  </div>

  <!-- Content -->
  <div class="content" fxLayout="column" fxLayoutAlign="center center">
    <div class="balance">{{ asset.balance }}</div>
    <div class="currency">EUR</div>
    <div class="asset-name" *ngIf="!isZeroToken && policyName">{{ policyName }}</div>
  </div>

  <!-- Policy Summary (for policy-bound tokens) -->
  <div class="policy-summary" *ngIf="!isZeroToken">
    <div class="policy-row" fxLayout="row" fxLayoutAlign="space-between center">
      <div class="policy-text-container">
        <div class="policy-label">Conditions:</div>
        <div class="policy-text">{{ policySummary }}</div>
      </div>
      <button mat-icon-button class="details-btn" (click)="openPolicyDetails($event)" matTooltip="View full policy details">
        <mat-icon>info_outline</mat-icon>
      </button>
    </div>

    <div class="indicators" fxLayout="row" fxLayoutGap="8px">
      <div class="permanent-indicator" *ngIf="isPermanentPolicy">
        <mat-icon>all_inclusive</mat-icon>
        <span>Permanent</span>
      </div>

      <div class="chained-indicator" *ngIf="hasChainedConditions">
        <mat-icon>link</mat-icon>
        <span>Chained</span>
      </div>
    </div>
  </div>

  <!-- Footer - ALWAYS VISIBLE -->
  <div class="footer" fxLayout="row" fxLayoutAlign="space-between center">
    <div class="token-id" *ngIf="!isZeroToken" [matTooltip]="asset.id">
      {{ asset.id.slice(0, 10) }}...
    </div>
    <div class="token-id" *ngIf="isZeroToken">
      Available Balance
    </div>
    <button
      mat-stroked-button
      class="transfer-btn"
      (click)="onTransfer($event)"
    >
      <mat-icon>send</mat-icon>
      Transfer
    </button>
  </div>
</div>
